


































import { defineComponent, onUnmounted, ref } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import providers from "@/lib/api";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import { OlecamsLiveRoom } from "@/types/olecams";

interface MappedLiveData {
  id: string;
  nick: string;
  thumb: string;
  status: string;
  age: number;
  country: string;
  langs: string[];
  credits_private: number;
  credits_vip: number;
  roomMode: string;
}

const swiperOptions: SwiperOptions = {
  slidesPerView: 2,
  slidesPerGroup: 2,
  spaceBetween: 8,
  grabCursor: true,
  navigation: {
    prevEl: ".lives-widget__nav-prev",
    nextEl: ".lives-widget__nav-next",
  },
  breakpoints: {
    376: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 8,
    },
  },
};

export default defineComponent({
  name: "LivesWidget",
  components: { BaseImage, BaseSpinner, BaseIcon, EmptyContent, Swiper, SwiperSlide },
  setup() {
    const mappedData = ref<MappedLiveData[]>([]);
    const loading = ref(false);
    let timer: ReturnType<typeof setInterval> | null = null;

    const adapterOlecamsLiveRoomToMappedLiveData = (data: OlecamsLiveRoom[]): MappedLiveData[] =>
      data.map(item => ({
        id: String(item.id),
        nick: item.nick,
        thumb: item.thumb,
        status: item.status,
        age: item.age,
        country: item.country,
        langs: item.langs,
        credits_private: item.credits_private,
        credits_vip: item.credits_vip,
        roomMode: item.roomMode,
      }));

    const getRooms = async () => {
      const response: OlecamsLiveRoom[] = await providers.OlecamsProvider.getAllRooms();
      mappedData.value = adapterOlecamsLiveRoomToMappedLiveData(response);
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getRooms();
        timer = setInterval(getRooms, 30000);
      } finally {
        loading.value = false;
      }
    };

    getData();

    onUnmounted(() => {
      timer && clearInterval(timer);
    });

    return {
      loading,
      mappedData,
      swiperOptions,
    };
  },
});
